import { Redis } from '@upstash/redis'
import { config } from './config'

const redis = new Redis({
  url: config.upstashRedis.main.url,
  token: config.upstashRedis.main.token
})

export { redis }
